import { useEffect } from "react";
import type { ReactNode } from "react";
import EdgeLogo from "components/Design/EdgeLogo/EdgeLogo";
import "./PlgSignup.scss";

const BODY_SCROLL_CLASS = "plg-signup-open";

interface PlgSignupLayoutProps {
  children: ReactNode;
  width?: "sm" | "md";
}

function PlgSignupLayout({ children, width = "sm" }: PlgSignupLayoutProps) {
  useEffect(() => {
    document.body.classList.add(BODY_SCROLL_CLASS);
    return () => document.body.classList.remove(BODY_SCROLL_CLASS);
  }, []);

  return (
    <div className="plg-signup">
      <div className="plg-signup__logo">
        <EdgeLogo size="md" state="dark" />
      </div>
      <div className={`plg-signup__card${width === "md" ? " plg-signup__card--md" : ""}`}>{children}</div>
    </div>
  );
}

export default PlgSignupLayout;
